import { BrowserRouter, useRoutes } from "react-router-dom";
import useRoutesMap from "./routesMap";

const Routes = () => {
  const routes = useRoutesMap();
  const Routes = () => useRoutes(routes);

  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
};

export default Routes;
